<template>
  <div class="number">
    <img :src="img">
  </div>
</template>
<script>
export default {
  name: 'SlotBall',
  props: {
    lang: {
      type: String,
      required: true
    },
    select: {
      type: [Number, String],
      default: 0
    },
    timeout: {
      type: Number,
      default: 10
    },
    start: {
      type: Number,
      default: 0
    },
    endTime: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      stopped: false,
      Interval: null,
      setTimeout: null,
      number: 0,
      running: 0
    }
  },
  computed: {
    img() {
      if(this.stopped) {
        return require(`@/assets/theme/${this.lang}/${this.select.toString()}.png`)
      }else{
        return require(`@/assets/theme/${this.lang}/${this.number.toString()}.png`)
      }
    },
    selectBall() {
      return require(`@/assets/theme/${this.lang}/${this.select.toString()}.png`)
    }
  },
  watch: {
    timeout(n, o) {
      if(n!==o) {
        console.log('re_spinning...', this.timeout)
        this.spinning()
      }
    }
  },
  methods: {
    spinning() {
      clearInterval(this.Interval)
      this.Interval = setInterval(() => {
        this.running++;
        this.number = this.running % 10
      }, 120);

      clearTimeout(this.setTimeout)
      this.setTimeout = setTimeout(()=>{
        if(this.select ) {
          this.stopped = true
          clearInterval(this.Interval)
        }
      }, this.timeout)
    }
  },
  mounted() {
    this.running = this.start
    this.spinning()
  },
  beforeDestroy() {
    clearInterval(this.Interval)
    clearTimeout(this.setTimeout)
  }
}
</script>
